import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppStateTypes } from '../../../store/appStateTypes';
import { Sparkles, PenLine, ALargeSmall, Tag, BookOpen } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@pisaka/ui';
import {
  basePageUrl, fontCreatorPageUrl, aiPageUrl, pricingPageUrl, flashcardsPageUrl
} from '../../../helpers/urls';

const Item: FC<{ href: string; icon: React.ReactNode; label: string; badge?: string; active?: boolean }> = ({ href, icon, label, badge, active }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <a
        href={href}
        className={`relative flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-150 ${active ? 'text-gray-900 bg-gray-100' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`}
      >
        {icon}
        {badge && (
          <span className="absolute -top-1.5 -right-1 text-[8px] font-bold leading-none px-1 py-0.5 rounded-full bg-red-500 text-white uppercase">
            {badge}
          </span>
        )}
      </a>
    </TooltipTrigger>
    <TooltipContent side="right" sideOffset={8} style={{ zIndex: 9999 }}>
      {label}
    </TooltipContent>
  </Tooltip>
);

export const MiniSidebarComponent: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { user } = useSelector((state: AppStateTypes) => state.auth) || {};

  return (
    <div className="mini-sidebar fixed left-0 top-[60px] w-14 h-[calc(100vh-60px)] bg-white border-r border-gray-200 flex-col items-center py-3 gap-1 z-[60]">
        <Item href={basePageUrl} icon={<PenLine className="w-5 h-5" />} label={t('sidebar.noteGenerator')} active={pathname === '/'} />
        <Item href={fontCreatorPageUrl} icon={<ALargeSmall className="w-5 h-5" />} label={t('sidebar.fontGenerator')} active={pathname.startsWith('/font-creator')} />
        <Item href={aiPageUrl} icon={<Sparkles className="w-5 h-5" />} label={t('sidebar.aiChat')} badge="new" active={pathname.startsWith('/ai')} />
        {Number(user?.id) === 1 && <Item href={flashcardsPageUrl} icon={<BookOpen className="w-5 h-5" />} label="Мои материалы" badge="new" active={pathname.startsWith('/materials')} />}
        <Item href={pricingPageUrl} icon={<Tag className="w-5 h-5" />} label={t('sidebar.pricing')} active={pathname.startsWith('/pricing')} />
    </div>
  );
};
